/*
 * File: ApptFiltersForm.js
 * Project: mp-mobile-app
 *
 * Created by Vamsi Sureddy
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Shows and populates the appointment filters form
 */
import React from "react";
import UIFilterForm from "components/filter-view/UIFilterForm";
import UIProgress from "components/ui/UIProgress";
import ApptFormOptions from "../store/ApptFormOptions";
import Users from "services/users/Users";
import ApptFilterFields from "../ApptFilterFields";
import FilterStore from "components/filter-view/FilterStore";
import DataForFormSelect from "utils/DataForFormSelect";
import PropTypes from "prop-types";
import { StoreContext } from "utils/useStore";
import PreferencesStore from "services/preferences/Store";

class ApptFilterForm extends React.Component {
  state = { loading: true };

  static contextType = StoreContext;

  constructor(props) {
    super(props);
    this.filterStore = FilterStore.create({ fields: ApptFilterFields });
  }

  componentDidMount() {
    this.props.onRef(this);
    this.populateFilterModel();
  }

  componentWillUnmount() {
    this.props.onRef(undefined);
  }

  /**
   * We need to update filter model options after we make api calls
   */
  async populateFilterModel() {
    const filters = this.context.getPreference("apptFilters");
    // fetch filter input data
    let resources = await this.context.getStore(ApptFormOptions).getResources();
    let providers = await this.context.getStore(Users).forSelect("providers");

    // update the filter model options
    this.setFormOptions(
      "resources",
      DataForFormSelect(resources, "resourceId", "name")
    );
    this.setFormOptions("providers", providers);

    //It will intialize the value of the filter fields based on given filter data.
    this.filterStore.mapDataToFormFields(filters);

    // we need to wait for the api responses before updating state
    this.updateState();
  }

  setFormOptions(key, val) {
    let field = this.filterStore.fields.find(m => m.name === key);
    field.setOptions(val);
  }

  updateState() {
    this.setState({
      loading: false
    });
  }

  submit() {
    let filters = {};
    for (var i = 0; i < this.filterStore.fields.length; i++) {
      let field = this.filterStore.fields[i];
      switch (field.name) {
        case "resources":
        case "providers":
          if (field.isAllOptionsSelected()) {
            filters[field.name] = "all";
            continue;
          }
          filters[field.name] = field.value.map(value => parseInt(value));
          break;
        case "order":
          filters[field.name] = parseInt(field.value);
          break;
        default:
          throw new Error(`Unhandled ApptFiltersForm field ${field.name}`);
      }
    }

    const prefs = this.context.getStore(PreferencesStore);
    prefs.apply("apptFilters", filters);
  }

  content = () => {
    return <UIFilterForm fields={this.filterStore.fields} />;
  };

  render() {
    let { loading } = this.state;
    return (
      <div>
        {loading && <UIProgress />}
        {!loading && this.content()}
      </div>
    );
  }
}

ApptFilterForm.propTypes = {
  onRef: PropTypes.func.isRequired
};

export default ApptFilterForm;
